<template>
	<el-form :model="form" class="form" label-width='200px'>
		
		<el-form-item label="拼团赠送自己功绩积分" >
			<el-input v-model.numbder="form.parm1"  autocomplete="off" placeholder="请输入jkc券计算参数"></el-input>
			<div style="color: red;">功绩积分计算=产品赠送积分×{{form.parm1}}%——N 可调</div>
		</el-form-item>
		<el-form-item label="拼团赠送上级服务积分参数" >
				<el-input v-model.numbder="form.parm33"  autocomplete="off" placeholder="请输入下级购买赠送上级jkc卷参数"></el-input>
				<div style="color: red;">下级购买产品赠送上级服务积分，下级赠送的积分×N%的N</div>
		</el-form-item>
		<el-form-item label="红色积分产出">
			<el-input v-model.numbder="form.parm65"  autocomplete="off" placeholder="奖励积分产量×N%×M%的M"></el-input>
			<div style="color: red;">质押产出N%红色积分的N</div>
		</el-form-item>
		<el-form-item label="每日专属任务完成次数">
			<el-input v-model.numbder="form.parm2"  autocomplete="off" placeholder="请输入每日专属任务完成次数"></el-input>
			
		</el-form-item>
		<el-form-item label="每日专属任务播放时长（秒）">
			<el-input v-model.numbder="form.parm3"  autocomplete="off" placeholder="请输入每日专属任务播放时长"></el-input>
			
		</el-form-item>
		<el-form-item label="每日专属任务赠送">
			<el-input v-model.numbder="form.parm4"  autocomplete="off" placeholder="请输入每日专属任务赠送总jkc券"></el-input>			
		</el-form-item>
		<el-form-item label="签到播放时长（秒）">
			<el-input v-model.numbder="form.parm5"  autocomplete="off" placeholder="请输入签到播放时长（秒）"></el-input>			
		</el-form-item>
		<el-form-item label="连续签到7天奖励">
			<el-input v-model.numbder="form.parm20"  autocomplete="off" placeholder="请输入连续签到7天奖励"></el-input>
		</el-form-item>
		<el-form-item label="实名认证奖励">
			<el-input v-model.numbder="form.parm21"  autocomplete="off" placeholder="请输入连续签到7天奖励"></el-input>
		</el-form-item>
		<el-form-item label="客服码">
			<!-- <el-input v-model.numbder="form.parm6"  autocomplete="off" placeholder="请输入客服电话"></el-input>			 -->
			<el-upload class="avatar-uploader" :action="upImg+'/file/upload/pic'"
				:headers="headers" 
				accept=".png,.jpg"
				:on-error='onError'
				:show-file-list="false" :on-success="handleAvatarSuccess">
				<img v-if="form.parm6" :src="webUrl+form.parm6" class="avatar">
				<i v-else class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
			<!-- <el-input v-model="form.sort"  autocomplete="off" ></el-input> -->
			<div style="color: red;">请上传1:1的图片比例</div>
		</el-form-item>
		<el-form-item label="APP版本号">
			<el-input v-model="form.parm7"  autocomplete="off" placeholder="请输入APP版本号"></el-input>			
		</el-form-item>
		<el-form-item label="更新日志">
			<el-input v-model="form.parm26" :maxlength='70' style="outline: none;" type="textarea"  autocomplete="off" placeholder="请输入更新日志"></el-input>
			<div style="color: red;">更新日志日志最多输入70个字符 （{{form.parm26.length}}/70）</div>
		</el-form-item>
		<el-form-item label="每日提现次数">
			<el-input v-model.numbder="form.parm8"  autocomplete="off" placeholder="请输入每日提现次数"></el-input>			
		</el-form-item>
		<el-form-item label="拼团未拼中计算参数">
			<el-input v-model.numbder="form.parm10"  autocomplete="off" placeholder="请输入拼团未拼中计算参数"></el-input>			
			<div style="color: red;">拼团未拼中的人，每人奖励【商品积分*M%/（N-1）】的M</div>
		</el-form-item>
		<el-form-item label="赠送上级贡献值封顶参数">
			<el-input v-model.numbder="form.parm11"  autocomplete="off" placeholder="请输入奖励上级贡献值上限封顶参数"></el-input>			
			<div style="color: red;">下级会员购买商品奖励上级贡献值上限封顶N</div>
		</el-form-item>
		<el-form-item label="赠送上级贡献值计算参数">
			<el-input v-model.numbder="form.parm12"  autocomplete="off" placeholder="请输入赠送上级贡献值计算参数"></el-input>			
			<div style="color: red;">赠送上级贡献值:产品赠送有效积分*N%的N</div>
		</el-form-item>
		<!-- <el-form-item label="贡献值减产参数">
			<el-input v-model.numbder="form.parm13"  autocomplete="off" placeholder="请输入贡献值减产参数"></el-input>			
			<div style="color: red;">全网贡献值每增加 N 贡献值减产的N</div>
		</el-form-item> -->
		<el-form-item label="JKC券价值计算参数">
			<el-input v-model.numbder="form.parm14"  autocomplete="off" placeholder="请输入JKC券价值计算参数"></el-input>			
			<div style="color: red;">JKC券价值计算公式:全网营业积分*15.4%*N%/全网JKC券总量 中的N</div>
		</el-form-item>
		<!-- <el-form-item label="JKC券兑换JKS参数">
			<el-input v-model.numbder="form.parm15"  autocomplete="off" placeholder="请输入JKC券兑换JKS参数"></el-input>			
			<div style="color: red;">1个JKC券兑换N个JKS 中的N</div>
		</el-form-item> -->
		<el-form-item label="奖励上级JKC券上限封顶参数">
			<el-input v-model.numbder="form.parm16"  autocomplete="off" placeholder="请输入奖励上级JKC券上限封顶参数"></el-input>			
			<div style="color: red;">下级会员购买商品奖励上级JKC券上限封顶N</div>
		</el-form-item>
		<el-form-item label="升级到分润合伙人所需兑换积分">
			<el-input v-model.numbder="form.parm17"  autocomplete="off" placeholder="请输入所需累计兑换积分参数"></el-input>			
			<div style="color: red;">普通合伙人升级到分润合伙人所需累计兑换积分N</div>
		</el-form-item>
		<el-form-item label="升级到贡献合伙人所需贡献值">
			<el-input v-model.numbder="form.parm24"  autocomplete="off" placeholder="请输入升级到贡献合伙人所需贡献值"></el-input>			
			<div style="color: red;">分润合伙人升级到贡献合伙人所需累计贡献值N</div>
		</el-form-item>
		<el-form-item label="升级到创业合伙人所需贡献值">
			<el-input v-model.numbder="form.parm25"  autocomplete="off" placeholder="请输入升级到创业合伙人所需贡献值"></el-input>			
			<div style="color: red;">贡献合伙人升级到创业合伙人所需累计贡献值N</div>
		</el-form-item>
		<el-form-item label="消费积分分润值参数">
			<el-input v-model.numbder="form.parm18"  autocomplete="off" placeholder="请输入消费积分分润值参数"></el-input>
			<div style="color: red;">当日后台营业积分*15.4%*N%/昨日全网消费积分分润值*个人账户=分润个人账户总量中的N</div>
		</el-form-item>
		
		<el-form-item label="当前消费积分分润池分出参数">
			<el-input v-model.numbder="form.parm19"  autocomplete="off" placeholder="请输入当前消费积分分润池分出参数"></el-input>
			<div style="color: red;">当前全网分润奖金池剩余总量*N%/当前全网总消费积分分润值量*个人账户=分润个人账户总量中的N</div>
		</el-form-item>
		<el-form-item label="几天解冻积分">
			<el-input v-model.numbder="form.parm22"  autocomplete="off" placeholder="请输入几天解冻积分"></el-input>			
		</el-form-item>
		<el-form-item label="赠送上级红利钱包参数">
			<el-input v-model.numbder="form.parm23"  autocomplete="off" placeholder="请输入赠送上级红利钱包参数"></el-input>	
			<div style="color: red;">赠送上级红利钱包：下级购买产品的营业积分*15.4%*N%*90%中的N</div>		
		</el-form-item>
		<el-form-item label="绩效劵波比参数">
			<el-input v-model.numbder="form.parm27"  autocomplete="off" placeholder="请输入绩效劵波比参数"></el-input>	
			<div style="color: red;">全网营业积分×15.4%×N%÷JKS绩效券总量×90% 中的N</div>		
		</el-form-item>
		<el-form-item label="参与消费获得JKC奖励">
			<el-input v-model.numbder="form.parm28"  autocomplete="off" placeholder="请输入参与消费获得JKC奖励"></el-input>	
			<div style="color: red;">参与消费获得JKC奖励xN%中的N</div>		
		</el-form-item>
		
		<el-form-item label="新增贡献值达标参数">
			<el-input v-model.numbder="form.parm30"  autocomplete="off" placeholder="请输入新增贡献值达标参数"></el-input>	
			<div style="color: red;">每月已经成为创业合伙人的，每新增N贡献值，奖励M个创业绩效分中的N</div>		
		</el-form-item>
		<el-form-item label="奖励M个创业绩效分中的M">
			<el-input v-model.numbder="form.parm31"  autocomplete="off" placeholder="请输入奖励M个创业绩效分中的M"></el-input>	
			<div style="color: red;">每月已经成为创业合伙人的，每新增N贡献值，奖励M个创业绩效分中的M</div>		
		</el-form-item>
		<el-form-item label="绩效分当月分红占比参数">
			<el-input v-model.numbder="form.parm32"  autocomplete="off" placeholder="请输入绩效分当月分红占比参数"></el-input>	
			<div style="color: red;">参与创业绩效分分红，【每月1日到31日营业积分总和×15.4%×N%】÷全网总创业绩效分×个人账户创业绩效分量×90%=个人账户当月分红量中的N</div>		
		</el-form-item>
		
		
		
		<el-form-item label="当前JKC价值">
			<el-input v-model.numbder="form.currentJKCValue"  autocomplete="off" placeholder="请输入拼团成团人数"></el-input>			
		</el-form-item>
		
		
		<!-- <el-form-item label="未达减产贡献值累计">
			<el-input v-model.numbder="form.subContribution" autocomplete="off" placeholder="请输入全网总贡献值"></el-input>			
		</el-form-item> -->
		<el-form-item label="全网总贡献值">
			<el-input v-model.numbder="form.totalContribution" disabled autocomplete="off" placeholder="请输入全网总贡献值"></el-input>			
		</el-form-item>
		<el-form-item label="全网营业积分">
			<el-input v-model.numbder="form.totalIntegral" disabled autocomplete="off" placeholder="请输入全网总贡献值"></el-input>
		
		</el-form-item>
		<el-form-item label="全网总创业绩效分">
			<el-input v-model.numbder="form.parm29" disabled autocomplete="off" placeholder="全网总创业绩效分"></el-input>	
			
		</el-form-item>
		<el-form-item label="全网JKC券">
			<el-input v-model.numbder="form.totalJKC" disabled autocomplete="off" placeholder="请输入全网JKC券"></el-input>			
		</el-form-item>
		<el-form-item label="全网JKS券">
			<el-input v-model.numbder="form.totalJKS" disabled autocomplete="off" placeholder="请输入全网JKS券"></el-input>			
		</el-form-item>
		<el-form-item label="全网功绩券">
			<el-input v-model.numbder="form.totalPhysicalTicket" disabled autocomplete="off" placeholder="请输入全网分红券"></el-input>			
		</el-form-item>
		<el-form-item label="昨日全网分润后剩余总量">
			<el-input v-model.numbder="form.totalShareBps" disabled autocomplete="off" placeholder="请输入昨日全网分润后剩余总量"></el-input>
		</el-form-item>

		<el-form-item label="推荐消费赠送上级JKC参数">
			<el-input v-model.numbder="form.parm33"  autocomplete="off" placeholder="推荐消费赠送上级JKC参数"></el-input>	
			<div style="color: red;">下级购买产品赠送上级jkc卷，下级赠送的积分×N%的N</div>		
		</el-form-item>

		<el-form-item label="支付多少钱必须上传发票">
			<el-input v-model.numbder="form.parm34"  autocomplete="off" placeholder="请输入个人账户当月分红量中的N"></el-input>	
			<div style="color: red;">商家入驻，支付金额≥N元时，必须上传真实发票的N</div>		
		</el-form-item>

		<el-form-item label="商家单日提现最高次数">
			<el-input v-model.numbder="form.parm35"  autocomplete="off" placeholder="商家单日提现最高N次的N"></el-input>	
			<div style="color: red;">商家单日提现最高N次的N</div>		
		</el-form-item>

		<el-form-item label="首次下线支付赠送消费积分分润值">
			<el-input v-model.numbder="form.parm36"  autocomplete="off" placeholder="首次下线支付赠送N个消费积分分润值的N"></el-input>
			<div style="color: red;">首次下线支付赠送N个消费积分分润值的N</div>
		</el-form-item>

		<el-form-item label="管理员的JKC服务券库存账户">
			<el-input v-model.numbder="form.adminJkcAmount"  autocomplete="off" placeholder="管理员的JKC服务券库存账户"></el-input>
			<div style="color: red;">管理员的JKC服务券库存账户</div>
		</el-form-item>

		<el-form-item label="当前JKS价值">
			<el-input v-model.numbder="form.currentJKSValue" disabled autocomplete="off" placeholder="当前JKS价值"></el-input>	
			<div style="color: red;">当前JKS价值</div>		
		</el-form-item>

		<el-form-item label="线下支付赠送JKS参数">
			<el-input v-model.numbder="form.parm37"  autocomplete="off" placeholder="线下支付赠送JKS参数"></el-input>	
			<div style="color: red;">联盟商家使用红利金或jkc支付赠送jks，赠送积分 * N%的N</div>		
		</el-form-item>

		<el-form-item label="商家销售产品赠送生态积分参数">
			<el-input v-model.numbder="form.parm38"  autocomplete="off" placeholder="商家销售产品赠送生态积分参数"></el-input>	
			<div style="color: red;">联盟商家销售产品赠送商家生态积分分润值，销售产品总积分N%的N</div>		
		</el-form-item>

		<el-form-item label="推荐商家获得红利金参数">
			<el-input v-model.numbder="form.parm39"  autocomplete="off" placeholder="推荐商家获得红利金参数"></el-input>	
			<div style="color: red;">创业合伙人推荐商家销售产品后的奖励，商家销售线下有效积分×N‰的N</div>		
		</el-form-item>

		<el-form-item label="累计贡献值达到N时奖励JKS绩效券">
			<el-input v-model.numbder="form.parm40"  autocomplete="off" placeholder="首次下线支付赠送N个生态积分分润值的N"></el-input>	
			<div style="color: red;">累计贡献值达到N时，触发一次性奖励M个JKS绩效券的N</div>		
		</el-form-item>

		<el-form-item label="累计贡献值达到N时奖励的M">
			<el-input v-model.numbder="form.parm41"  autocomplete="off" placeholder="首次下线支付赠送N个生态积分分润值的N"></el-input>	
			<div style="color: red;">累计贡献值达到N时，触发一次性奖励M个JKS绩效券的M</div>		
		</el-form-item>

		<el-form-item label="jkc价格基数N">
			<el-input v-model.numbder="form.jkcBasePrice"  autocomplete="off" placeholder="jkc价格基数N"></el-input>	
			<div style="color: red;">jkc价格基数N</div>		
		</el-form-item>
		<el-form-item label="jkc价格每增加N%，减产M%的N">
			<el-input v-model.numbder="form.parm42"  autocomplete="off" placeholder="jkc价格每增加N%，减产M%的N"></el-input>	
			<div style="color: red;">jkc价格每增加N%，减产M%的N</div>		
		</el-form-item>
		<el-form-item label="jkc价格每增加N%，减产M%的M">
			<el-input v-model.numbder="form.parm43"  autocomplete="off" placeholder="jkc价格每增加N%，减产M%的M"></el-input>	
			<div style="color: red;">jkc价格每增加N%，减产M%的M</div>		
		</el-form-item>
		<el-form-item label="每质押100红色积分=N（默认10）个活跃度的N">
			<el-input v-model.numbder="form.parm46"  autocomplete="off" placeholder="每质押100红色积分=N（默认10）个活跃度的N"></el-input>
			<div style="color: red;">每质押100红色积分=N（默认10）个活跃度的N</div>
		</el-form-item>
		<el-form-item label="活跃度最大值M（默认1000）">
			<el-input v-model.numbder="form.parm47"  autocomplete="off" placeholder="活跃度最大值M（默认1000）"></el-input>	
			<div style="color: red;">活跃度最大值M（默认1000）</div>		
		</el-form-item>
		<el-form-item label="服务积分兑换红利金扣除红色积分N%的N">
			<el-input v-model.numbder="form.parm48"  autocomplete="off" placeholder="服务积分兑换红利金扣除多赠额度N%的N"></el-input>
			<div style="color: red;">服务积分兑换红利金扣除多赠额度N%的N</div>
		</el-form-item>
		<el-form-item label="服务积分兑换JKC服务券扣除手续费N%的N（默认10%）">
			<el-input v-model.numbder="form.parm50"  autocomplete="off" placeholder="通证积分兑换JKC仓池扣除手续费N%的N（默认10%）"></el-input>	
			<div style="color: red;">服务积分兑换JKC服务券N%的N（默认10%）</div>
		</el-form-item>
		<el-form-item label="1个服务积分兑换N个红利金的N（默认1）">
			<el-input v-model.numbder="form.parm51"  autocomplete="off" placeholder="1个服务积分兑换N个红利金的N（默认1）"></el-input>
			<div style="color: red;">1个服务积分兑换N个红利金的N（默认1）</div>
		</el-form-item>
		<el-form-item label="推广专区JKC价值计算">
			<el-input v-model.numbder="form.parm52"  autocomplete="off" placeholder="JKC币价值计算公式:全网总奖励积分（产出）*N% 中的N（默认10%）"></el-input>
			<div style="color: red;">JKC服务券价值计算公式:全网总奖励积分（产出）*N% 中的N（默认10%）</div>
		</el-form-item>
		<el-form-item label="直推赠送N%活跃度中的N（默认50%）">
			<el-input v-model.numbder="form.parm53"  autocomplete="off" placeholder="直推赠送N%活跃度中的N（默认50%）"></el-input>	
			<div style="color: red;">直推赠送N%活跃度中的N（默认50%）</div>		
		</el-form-item>
		<el-form-item label="间推赠送N%活跃度中的N（默认50%）">
			<el-input v-model.numbder="form.parm54"  autocomplete="off" placeholder="间推赠送N%活跃度中的N（默认50%）"></el-input>	
			<div style="color: red;">间推赠送N%活跃度中的N（默认50%）</div>		
		</el-form-item>
		<el-form-item label="服务积分兑换JKC倍数N（默认100）">
			<el-input v-model.numbder="form.parm55"  autocomplete="off" placeholder="服务积分兑换JKC倍数N（默认100）"></el-input>
			<div style="color: red;">服务积分兑换JKC倍数N（默认100）</div>
		</el-form-item>
		<el-form-item label="升级V5条件">
			<el-input v-model.numbder="form.parm56"  autocomplete="off" placeholder="个人贡献值达到N时，升级的N"></el-input>	
			<div style="color: red;">个人贡献值达到N时，升级的N</div>		
		</el-form-item>
		<el-form-item label="V4补贴奖励">
			<el-input v-model.numbder="form.parm57"  autocomplete="off" placeholder="服务积分产量×N%×M%的N"></el-input>
			<div style="color: red;">服务积分产量×N%×M%的N</div>
		</el-form-item>
		<el-form-item label="V4补贴奖励">
			<el-input v-model.numbder="form.parm58"  autocomplete="off" placeholder="服务积分产量×N%×M%的M"></el-input>
			<div style="color: red;">服务积分产量×N%×M%的M</div>
		</el-form-item>
		<el-form-item label="推广区送自己红色积分"> 
			<el-input v-model.numbder="form.parm59"  autocomplete="off" placeholder="商品赠送上级的服务积分×（N%+1）的N"></el-input>
			<div style="color: red;">商品赠送上级的服务积分×（N%+1）的N</div>
		</el-form-item>
		<el-form-item label="V6奖励">
			<el-input v-model.numbder="form.parm63"  autocomplete="off" placeholder="服务积分产量×N%×M%的N"></el-input>
			<div style="color: red;">服务积分产量×N%补贴奖励×M%补贴奖励的N</div>
		</el-form-item>
		<el-form-item label="V6补贴奖励">
			<el-input v-model.numbder="form.parm64"  autocomplete="off" placeholder="服务积分产量×N%×M%的M"></el-input>
			<div style="color: red;">服务积分产量×N%补贴奖励×M%补贴奖励的M</div>
		</el-form-item>
		<el-form-item label="实体云账本目标分红券">
			<el-input v-model.numbder="form.parm66"  autocomplete="off" placeholder="实体云账本目标分红券 = 目标额度 / N的N"></el-input>
			<div style="color: red;">实体云账本目标分红券 = 目标额度 / N的N</div>
		</el-form-item>
		<el-form-item label="功绩积分释放">
			<el-input v-model.numbder="form.parm67"  autocomplete="off" placeholder="绿色积分每天释放N%"></el-input>
			<div style="color: red;">功绩积分每天释放N%</div>
		</el-form-item>
		<el-form-item label="JKD设定价值">
			<el-input v-model.numbder="form.parm68"  autocomplete="off" placeholder="JKD设定价值N"></el-input>
			<div style="color: red;">JKD设定价值N</div>
		</el-form-item>
		
		<div style="text-align: center;"><el-button type="primary" @click="sub()">确 定</el-button>	</div>
	</el-form>
	
</template>

<script>
	export default {
		data() {
			return {
				form: {},
				webUrl:this.webUrl,
				webImgUrl:this.webImgUrl,
				headers:{
					'token':this.$store.state.token,
					// 'Content-Type': 'multipart/form-data'
				},
			}
		},
		created() {
			this.getConfig()
		},
		methods: {
			//正整数
			integer(str) {
			    var regexp = /^[1-9]\d*$/;
			    if (!regexp.test(str)) {
			        return false;
			    }
			    return true;
			},
			//大于0
			decimal(str) {
				var regexp = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
				if (!regexp.test(str)) {
					return false;
				}
				return true;
			},
			//确定提交
			sub(){
				if(!this.decimal(this.form.parm1)){
					this.$message('请输入大于0的jkc券计算参数');
					return false
				}
				if(!this.decimal(this.form.parm33)){
					this.$message('请输入大于0的下级购买赠送上级jkc卷参数');
					return false
				}
				this.form.parm33=parseFloat(this.form.parm33)
				if(!this.integer(this.form.parm2)){
					this.$message('请输入大于0的正整数每日专属任务完成次数');
					return false
				}
				if(!this.integer(this.form.parm3)){
					this.$message('请输入大于0的正整数每日专属任务播放时长（秒）');
					return false
				}
				if(!this.decimal(this.form.parm4)){
					this.$message('请输入大于0的每日专属任务赠送总jkc券');
					return false
				}
				if(!this.integer(this.form.parm5)){
					this.$message('请输入大于0的正整数签到播放时长（秒）');
					return false
				}
				if(!this.decimal(this.form.parm20)){
					this.$message('请输入大于0的连续签到7天奖励JKC券个数');
					return false
				}
				if(!this.decimal(this.form.parm21)){
					this.$message('请输入大于0的实名认证奖励JKC券个数');
					return false
				}
				
				
				if(this.form.parm6.length==0){
					this.$message('请输入上传客服二维码');
					return false
				}
				if(this.form.parm7.length==0){
					this.$message('请输入APP版本号');
					return false
				}
				if(this.form.parm26.length==0){
					this.$message('请输入更新日志');
					return false
				}
				if(!this.integer(this.form.parm8)){
					this.$message('请输入大于0的正整数每日提现次数');
					return false
				}
				// if(!this.integer(this.form.parm9)){
				// 	this.$message('请输入大于0的正整数拼团成团人数');
				// 	return false
				// }
				
				if(!this.decimal(this.form.parm10)){
					this.$message('请输入大于0的拼团未拼中计算参数');
					return false
				}
				if(!this.decimal(this.form.parm11)){
					this.$message('请输入大于0的奖励上级贡献值上限封顶参数');
					return false
				}
				if(!this.decimal(this.form.parm12)){
					this.$message('请输入大于0的赠送上级贡献值计算参数');
					return false
				}
				if(!this.decimal(this.form.parm13)){
					this.$message('请输入大于0的贡献值减产参数');
					return false
				}
				if(!this.decimal(this.form.parm14)){
					this.$message('请输入大于0的JKC券价值计算参数');
					return false
				}
				if(!this.decimal(this.form.parm15)){
					this.$message('请输入大于0的JKC券兑换JKS参数');
					return false
				}
				if(!this.decimal(this.form.parm16)){
					this.$message('请输入大于0的奖励上级JKC券上限封顶参数');
					return false
				}
				if(!this.decimal(this.form.parm17)){
					this.$message('请输入大于0的升级到分润合伙人所需兑换积分');
					return false
				}
				if(!this.decimal(this.form.parm24)){
					this.$message('请输入大于0的升级到贡献合伙人所需贡献值');
					return false
				}
				if(!this.decimal(this.form.parm25)){
					this.$message('请输入大于0的升级到创业合伙人所需贡献值');
					return false
				}
				if(!this.decimal(this.form.parm18)){
					this.$message('请输入大于0的分润个人账户总量参数');
					return false
				}
				if(!this.decimal(this.form.parm19)){
					this.$message('请输入大于0的当前全网分润奖金池剩余总量');
					return false
				}
				if(!this.integer(this.form.parm22)){
					this.$message('请输入大于0的正整数几天解冻积分（默认7）');
					return false
				}
				if(!this.decimal(this.form.parm23)){
					this.$message('请输入大于0的赠送上级红利钱包参数');
					return false
				}
				if(!this.decimal(this.form.parm27)){
					this.$message('请输入大于0的全网营业积分绩效券总量');
					return false
				}
				this.form.parm27=parseFloat(this.form.parm27)
				if(!this.decimal(this.form.parm28)){
					this.$message('请输入大于0的参与消费获得JKC奖励');
					return false
				}
				// if(!this.decimal(this.form.parm29)){
				// 	this.$message('请输入大于0的全网总创业绩效分');
				// 	return false
				// }
				if(!this.decimal(this.form.parm30)){
					this.$message('请输入大于0的奖励M个创业绩效分中的N');
					return false
				}
				if(!this.decimal(this.form.parm31)){
					this.$message('请输入大于0的奖励M个创业绩效分中的M');
					return false
				}
				if(!this.decimal(this.form.parm32)){
					this.$message('请输入大于0的个人账户当月分红量中的N');
					return false
				}
				
				
				if(this.form.totalContribution!=0){
					if(!this.integer(this.form.totalContribution)){
						this.$message('请输入大于等于0的正整数全网总贡献值');
						return false
					}
				}
				
				this.httpPut('/basicConfig/update', this.form, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					if (res.code == 200) {
						this.$message.success('修改成功');
						this.dialogVisible = false
					}
				})
			},
					
			getConfig() {
				this.httpPost("/basicConfig/getOne").then(res => {
					if (res.code == 200) {
						console.log(res.data)
						this.form = res.data
						// ''this.form.parm33=0
					}
				})
			},
			//上传封面图片回调
			handleAvatarSuccess(res, file) {
				this.form.parm6 = res.data.path
			},			
			onError(){
				this.$message.error("上传失败")
			},

		},


	}
</script>

<style>
	.form{
		width: 100%;
		padding: 20px 0 ;
		/* display: flex;
		justify-content: space-between;
		flex-wrap: wrap; */
		
		/* text-align: center; */
	}
	/* ::v-deep .el-form-item{
		width: 45% !important;
	} */
	/* ::v-deep .el-textarea .el-textarea__inner{
		width: 800px;
		height: 150px;
	} */
	.avatar-uploader .el-upload {
		/* border-radius: 6px; */
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		border: 1px solid #d9d9d9 !important;
		line-height: 178px !important;
		text-align: center;
	}
	
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
		margin-right: 10px;
	}
</style>
